<section class="bg-white rounded-lg">
  <h2 class="text-[#293834] text-2xl font-bold mb-6">
    {{ 'impact.ademe.title' | transloco }}
  </h2>

  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
    @for (eq of displayedEquivalences(); track eq.slug) {
      <div class="text-center border border-greyscale-200 rounded-lg p-6">
        <div class="bg-primary-100 w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center">
          <lucide-angular
            [img]="getIcon(eq.slug)"
            class="w-6 h-6 text-primary-600"
          ></lucide-angular>
        </div>
        @if (isLessThanOne(eq.value)) {
          <div
            class="text-2xl font-bold text-greyscale-900 mb-2 cursor-help"
            [pTooltip]="'impact.ademe.lessThanOne.tooltip' | transloco"
            tooltipPosition="top"
          >
            {{ eq.displayValue }}
          </div>
        } @else {
          <div class="text-2xl font-bold text-greyscale-900 mb-2">
            {{ eq.displayValue }}
          </div>
        }
        <div class="text-greyscale-600 text-sm">
          {{ eq.labelKey | transloco }} {{ eq.unitKey | transloco }}
        </div>
      </div>
    } @empty {
      <div class="col-span-full text-center py-8 text-greyscale-600">
        {{ 'impact.ademe.noData' | transloco }}
      </div>
    }
  </div>
</section>
